<template>
  <div class="main-contents" style="">
    <p class="label-row">オンライン専門ZOOMコンパニオン「ズムトーーーク☆」</p>
    <a href="/"><h1 id="top-titile"><img src="../../assets/img-top-pc.jpg" id="header-image" alt="オンライン専門ZOOMコンパニオン ズムトーーーク"><img src="../../assets/img-top-sp.jpg" alt="オンライン専門ZOOMコンパニオン ズムトーーーク" id="mobile-header-image"></h1></a>
    <div id="web-menu">
      <header>
          <ul>
            <a href="/"><li>トップページ</li></a>
            <a href="/menu"><li>料金システム</li></a>
            <a href="/companion"><li>コンパニオン</li></a>
            <a href="/service"><li>サービス紹介</li></a>
            <a href="/contact"><li style="border-right: 2px outset white;">お問い合わせ</li></a>
          </ul>
    </header>
    </div>
    <img v-on:click="showMenu()" src="../../assets/menu.png" id="sm-menu-icon" alt="メニュー">
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.label-row{
    background-color:#009900;
    line-height:50px;
    height: 50px;
  color:white;
  margin:0px;
}
#mobile-header-image{
  display: none;
}
header li {
  display: inline-block;
}
header{
  background-image: url(../../assets/bg-g-navi.jpg);
  height: 100px;
  background-size:contain;
}
ul {
  padding :0px;
  height: 100%;
  margin:0px;
}
li{
   height: 100px;
   padding-left: 8px;
   padding-right: 8px;
   border-left: 2px outset white;
}
header a{
   color: white;
  text-decoration: none;
  font-size:24px;
  line-height:100px;
}
li:hover{
   background-color:#006600;
}

#header-image{
  width: 70%;
}
#sm-menu-icon{
  display: none;
}
#sm-menu{
  display: none;
}
h1{
  margin-top: 0px;
  margin-bottom: 0px;
}
@media ( max-width : 680px ){
    #header-image{
  width: 100%;
}
#web-menu{
  display: none;
}
.label-row{
  display: none;
}
#sm-menu-icon{
display: block;
width: 64px;
height:64px;
position: absolute;
top:8px;
right:8px;
background-color: black;
border-radius: 50%;
position: fixed;
z-index: 10000;
}
#subheader h1 img {
    width: 100%;
}
.main-contents{
  height: auto;
}
#sm-menu{
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
#header-image{
  display: none;
}

#mobile-header-image{
  display: block;
  width: 100%;
}
}
</style>
<script>
export default {
  name: 'app',
  methods: {
    showMenu: function () {
      document.getElementById('sm-menu-icon').style.display = 'none'
      document.getElementById('sm-menu').style.display = 'block'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Header.vue